import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from './shared/azure-authentication/authentication.guard';
import { LoginComponent } from './login/login.component';
import { OAuthCallbackHandler } from './shared/login-callback/oauth-callback.guard';
import { OAuthCallbackComponent } from './shared/login-callback/oauth-callback.component';
import { HomeComponent } from './home/home.component';
import { TeamsComponent } from './teams/teams.component';
import { CalendarComponent } from './calendar/calendar.component';
import { LoanProgramsComponent } from './loanprograms/loanprograms.component';
import { CollateralskillsetsComponent } from './collateralskillsets/collateralskillsets.component';
import { ProcessorCloserPipelineReassignmentComponent } from './processor-closer-pipeline-reassignment/processor-closer-pipeline-reassignment.component';
import { LoanAssignmentComponent } from './loan-assignment/loanassignment.component';
import { LoanOfficerRegionReferenceComponent } from './loan-officer-region-reference/loanofficerregionreference.component';
import { UnderwriterTeamBalancerComponent } from './uw-team-balancer/uwteambalancer.component';

export const routes: Routes = [
    { path: '', redirectTo: 'teams', pathMatch: 'full' },
    { path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard] },
    { path: 'calendar', component: CalendarComponent, canActivate: [AuthenticationGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'teams', component: TeamsComponent, canActivate: [AuthenticationGuard] },
    { path: 'programs', component: LoanProgramsComponent, canActivate: [AuthenticationGuard] },
    { path: 'collateralskillsets', component: CollateralskillsetsComponent, canActivate: [AuthenticationGuard] },
    { path: 'id_token', component: OAuthCallbackComponent, canActivate: [OAuthCallbackHandler] },
    { path: 'reassignmentProcessorCloser', component: ProcessorCloserPipelineReassignmentComponent, canActivate: [AuthenticationGuard] },
    { path: 'loanassignment', component: LoanAssignmentComponent, canActivate: [AuthenticationGuard] },
    { path: 'loanOfficerRegionReference', component: LoanOfficerRegionReferenceComponent, canActivate: [AuthenticationGuard] },
    { path: 'uwTeamBalancer', component: UnderwriterTeamBalancerComponent, canActivate: [AuthenticationGuard] }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/app-route.ts